import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, SettlementAmount, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDateSplit, SearchRange, SearchSelect, SearchSelectText, SearchBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import { changeNum, datePickerCommonOpts, paintWeekendColors } from '../common/function';
import dayjs from 'dayjs';
import { isAgentUser } from '../../auth/loginDestination';

function SettlementsAgent() {
    let dispatch = useDispatch()
    let navigate = useNavigate();
    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(40)
    const [amount, setAmount] = useState([1000000, 50000])
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)
    const [queryError, setQueryError] = useState('');

    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [reload, setReload] = useState(false)
    const [amountResult, setAmountResult] = useState([])

    const brand = useSelector((state) => state.brand);
    const MyData = useSelector((state) => state.MyData);

    // 빠른/오앤유 체크박스 상태 (빠른 브랜드에서만 사용)
    const checkBoxList = ["빠른", "오앤유"];
    const [checkBoxAmount, setCheckBoxAmount] = useState(checkBoxList); // 기본적으로 모두 선택

    useEffect(() => {
        dispatch(change_Current_Location("에이전트 정산내역"))
        dispatch(changeHeaderTitle({
            mainTitle: "정산관리",
            subTitle: "에이전트 정산내역"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const handleChange = (event) => {
        setPage(1)
        setMaxFirstPage(Number(event.target.value));
    };

    // 기간 포맷 - 시작일/종료일 개별 선택
    const startInputRef = useRef(null);
    const endInputRef = useRef(null);
    const startPickerRef = useRef(null);
    const endPickerRef = useRef(null);

    useEffect(() => {
        startPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: startInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => {
                    setPage(1)
                    setPreDate(date.format('YYYY-MM-DD'));
                });
            }
        });

        endPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: endInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => {
                    setPage(1)
                    setNextDate(date.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            startPickerRef.current?.destroy();
            endPickerRef.current?.destroy();
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState()
    const [nextDate, setNextDate] = useState()

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수 (당일/전일/당월/전월 버튼에서 호출)
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        startPickerRef.current?.setDate(startDate);
        endPickerRef.current?.setDate(endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 영업자 포맷
    const select1 = ["전체", "지사", "총판", "대리점"]

    const [selectedValue, setSelectedValue] = useState("전체");
    const [selectedText, setSelectText] = useState("")

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
    };

    const handleSelectTextChange = (event) => {
        const value = event.target.value;
        setSelectText(value);
    };

    // 검색구분 포맷
    const select4 = ["매장명", "TID"]

    const [selectedValue3, setSelectedValue3] = useState("매장명");
    const [selectedText3, setSelectText3] = useState("")

    const handleSelectChange3 = (event) => {
        const value = event.target.value;
        setSelectedValue3(value);
    };

    const handleSelectTextChange3 = (event) => {
        const value = event.target.value;
        setSelectText3(value);
    };

    // 체크박스 토글 함수
    const toggleCheckbox = (value) => {
        setCheckBoxAmount((prev) =>
            prev.includes(value)
                ? prev.filter((item) => item !== value) // 선택 해제
                : [...prev, value] // 선택 추가
        );
    };

    useEffect(() => {
        ListData()
    }, [page, maxFirstPage, reload, preDate, nextDate, checkBoxAmount])

    const ListData = async () => {
        if (page === 1) setSpinner(true)
        setQueryError('');
        const tmpDate = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0];
        await axios.get(process.env.REACT_APP_API + "/api/settlement/agent", {
            withCredentials: true,
            timeout: 15000,
            params: {
                page: page,
                limit: maxFirstPage,
                salesCategory: selectedValue == "지사" ? 1 : selectedValue == "총판" ? 2 : selectedValue == "대리점" ? 3 : 0,
                salesValue: selectedText,
                searchCategory: selectedValue3 == "매장명" ? 1 : selectedValue3 == "TID" ? 2 : selectedValue3 == "승인번호" ? 3 : 0,
                searchValue: selectedText3,
                startDate: preDate ?? tmpDate,
                endDate: nextDate ?? tmpDate,
                settlementType: checkBoxAmount, // 빠른/오앤유 체크박스 값 전달
            }
        }).then((response) => {
            let tmp = response?.data
            if (isAgentUser(MyData) ? tmp?.code === 1000 : tmp?.code < 2000) {
                // console.log(tmp.data)
                setListData(tmp?.data ?? [])
                if (page === 1) {
                    setListTrxData(tmp?.data?.settlement ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.settlement ?? []]);
                }
                setAmountResult(tmp?.data?.summary ?? {})
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            } else if (isAgentUser(MyData)) {
                setQueryError(tmp?.msg || '정산 내역을 불러오지 못했습니다. 다시 조회해주세요.');
            }
            setSpinner(false)
        }).catch(error => {
            if (!isAgentUser(MyData) || error.response?.data?.code === 9999) {
                navigate('/');
            } else {
                setQueryError(error.response?.data?.msg || '정산 내역을 불러오지 못했습니다. 다시 조회해주세요.');
            }
        }).finally(() => {
            setSpinner(false);
        });
    }

    const tableHeaderData = [
        { "no": 1, "text": "정산일", "width": "100px", "textAlign": "center" },
        { "no": 17, "text": "에이전트 ID", "width": "100px", "textAlign": "center" },
        { "no": 2, "text": "에이전트명", "width": "130px", "textAlign": "center" },
        { "no": 6, "text": "거래금액", "width": "100px", "textAlign": "center" },
        { "no": 9, "text": "정산금", "width": "130px", "textAlign": "center" },
        { "no": 12, "text": "예금주명", "width": "100px", "textAlign": "center" },
        { "no": 13, "text": "은행명", "width": "100px", "textAlign": "center" },
        { "no": 14, "text": "계좌번호", "width": "130px", "textAlign": "center" },
        { "no": 16, "text": "입금적요", "width": "120px", "textAlign": "center" },
    ];

    useEffect(() => {
        let tableBodyData = [];

        if (listTrxData) {
            let list = listTrxData ?? []
            for (let i = 0; i < list.length; i++) {
                let data = list[i]
                tableBodyData.push([
                    { "no": 1, "text": data.trx_date.split(' ')[0], "width": "100px", "textAlign": "center" },
                    { "no": 17, "text": data.agent_id, "width": "100px", "textAlign": "center" },
                    { "no": 2, "text": data.co_nm, "width": "130px", "textAlign": "left" },
                    { "no": 6, "text": `${changeNum(Number(data.amt))}원`, "width": "100px", "textAlign": "right" },
                    { "no": 9, "text": `${changeNum(Number(data.fee))}원`, "width": "130px", "textAlign": "right" },
                    { "no": 12, "text": data.accnt_nm, "width": "100px", "textAlign": "center" },
                    { "no": 13, "text": data.bank_nm, "width": "100px", "textAlign": "left" },
                    { "no": 14, "text": data.accnt_no, "width": "130px", "textAlign": "left" },
                    { "no": 16, "text": data.payout_memo || '', "width": "120px", "textAlign": "center" },
                ])
            }
            setCombineData(tableBodyData)
        }
    }, [listTrxData])

    const excelListBtn = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/settlement/agent/excel", {
            withCredentials: true,
            params: {
                startDate: preDate,
                endDate: nextDate,
                agentId: "",
                settlementType: checkBoxAmount, // 빠른/오앤유 체크박스 값 전달
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                excelListData(tmp?.data?.settlement ?? [])
            }
        }).catch(error => {
            console.error(error);
            alert("날짜를 선택해주세요.");
        });
    }

    const excelListData = (exData) => {
        let arr = [];
        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]

                arr.push({
                    "정산일": t.trx_date.split(' ')[0],
                    "에이전트ID": t.agent_id,
                    "에이전트명": t.co_nm,
                    "거래금액": Number(t.amt),
                    "정산금": Number(t.fee),
                    "예금주명": t.accnt_nm,
                    "은행명": t.bank_nm,
                    "계좌번호": t.accnt_no,
                    "입금적요": t.payout_memo || ''
                })
            }
        }
        Excel(arr)
    }

    // 더보기 버튼
    const [moreBtn, setMoreBtn] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640) setMoreBtn(true)
            else setMoreBtn(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.totCnt >= page * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData]);

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            {queryError && <div role="alert" style={{padding:'16px', marginBottom:'16px', borderRadius:'12px', background:'#fff3f4', color:'#b33240'}}>
                <p>{queryError}</p>
                <p>정산 조회에 실패했습니다. 아래 금액과 내역은 최신 조회 결과가 아닐 수 있습니다.</p>
                <button type="button" onClick={onSubmitSearch} disabled={spinner} style={{minHeight:'44px', padding:'0 16px', marginTop:'8px', background:'#fff', border:'1px solid #efd2d5', borderRadius:'8px'}}>정산 다시 조회</button>
            </div>}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDateSplit
                        startInputRef={startInputRef}
                        endInputRef={endInputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={false}
                        state={true}
                    />

                    {moreBtn && <SearchSelectText type={"영업자"} selectData={select1} handleSelectChange={handleSelectChange} selectedValue={selectedValue} handleSelectTextChange={handleSelectTextChange} selectedText={selectedText} btnText={"검색"} onClick={() => onSubmitSearch()} />}

                    {brand.key === "fast" && MyData?.role === "SUPER" && (
                        <div className='input-disable' style={{ display: 'flex', gap: '8px', marginTop: '6px' }}>
                            {checkBoxList.map((item) => (
                                <label key={item}>
                                    <input
                                        type="checkbox"
                                        value={item}
                                        checked={checkBoxAmount.includes(item)}
                                        onChange={() => toggleCheckbox(item)}
                                        style={{ marginRight: "5px" }}
                                    />
                                    {item}
                                </label>
                            ))}
                        </div>
                    )}

                    {/* {moreBtn && <SearchSelectText type={"검색구분"} selectData={select4} handleSelectChange={handleSelectChange3} selectedValue={selectedValue3} handleSelectTextChange={handleSelectTextChange3} selectedText={selectedText3} />} */}

                    {/* <SearchBtn type={"검색"} onClick={() => onSubmitSearch()} /> */}
                </form>
                {/* <div className="more_wrap">
                    <button type="button" onClick={() => setMoreBtn(e => !e)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="chevron-down" data-lucide="chevron-down" className="lucide lucide-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg><span>더보기</span>
                    </button>
                </div> */}
            </div>
            <div className="intro-y box intro-padding" >
                <div className="tabulator_sorting_wrap">
                    <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end', margin: "0", width: "100%", gap: "10px" }}>
                        <SettlementAmount
                            approvedAmount={Number(amountResult?.approval_amt ?? 0)}
                            canceledAmount={Number(amountResult?.cancel_amt ?? 0)}
                            settlementAmount={Number(amountResult?.settlement_amt ?? 0)}
                            canceledFee={Number(amountResult?.canceled_fee ?? 0)}
                            companyProfit={Number(amountResult?.company_profit ?? 0)}
                        />
                        {/* <CountAmount tableBodyData={listData?.totCnt ?? 0} /> */}
                    </div>
                    <div className='excel-disable'>
                        <div className='flex gap-4'>
                            <DownloadBtn text={"엑셀 다운로드"} onClick={excelListBtn} />
                            {/* <DownloadBtn text={"입금 엑셀"} onClick={excelDepositBtn} /> */}
                        </div>
                        {/* <CountSelect onChange={handleChange} maxFirstPage={maxFirstPage} /> */}
                    </div>
                </div>
                {/* <div className="tabulator_summary_wrap">
                    <SettlementAmount 
                        approvedAmount={Number(amountResult?.approval_amt ?? 0)} 
                        canceledAmount={Number(amountResult?.cancel_amt ?? 0)} 
                        settlementAmount={Number(amountResult?.settlement_amt ?? 0)} 
                        canceledFee={Number(amountResult?.canceled_fee ?? 0)} 
                        companyProfit={Number(amountResult?.company_profit ?? 0)} 
                    />
                    <CountAmount tableBodyData={listData?.totCnt ?? 0} />
                </div> */}

                <List
                    tableHeaderData={tableHeaderData}
                    tableBodyData={listData?.totCnt ?? 0}
                    filter_tableBodyData={combineData}
                    page={page} setPage={setPage}
                    maxFirstPage={maxFirstPage}
                    observerRef={observerRef}
                    nonePage={false}
                    scrollState={true}
                    spinner={spinner}
                    height={"700px"}
                />

                <input type="hidden" id="fromDate" />
                <input type="hidden" id="toDate" />
                <input type="hidden" id="date_to_date" />
            </div>

        </div>
    )
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = '에이전트 정산내역';

    const headerRow = [
        "정산일", "에이전트ID", "에이전트명", "거래금액", "정산금", "예금주명", "은행명", "계좌번호", "입금적요"
    ];

    const bodyRows = excelData.map((data) => ([
        data.정산일, data.에이전트ID, data.에이전트명,
        Number(data.거래금액), Number(data.정산금), data.예금주명,
        data.은행명, data.계좌번호, data.입금적요
    ]));

    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['!cols'] = Array(headerRow.length).fill({ wpx: 100 });

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });

    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};


export default SettlementsAgent